<template>
  <div>
    <vx-card :title="info.name" class="mb-4" v-if="info">
    <div class="border-0 border-b border-solid border-grey-lighter py-base mb-base">
      <div class="flex items-center justify-around mx-auto" style="max-width: 800px">
        <div class="text-center">
          <h1 class="text-primary">{{sended}}</h1>
          <div>Отправлено</div>
        </div>
        <div class="text-center">
          <h1 class="text-success">{{delivered}}</h1>
          <div>Доставлено ({{getPercent(delivered, sended)}}%)</div>
        </div>
        <div class="text-center">
          <h1 class="text-danger">{{errors}}</h1>
          <div>Ошибок ({{getPercent(errors, sended)}}%)</div>
        </div>

      </div>
    </div>


      <div class="flex items-center" >
        <vue-apex-charts class="mt-5" style="min-width: 480px" type=donut height=325 :options="donateData.chartOptions" :series="donateData.series" />
        <div class="flex-1 px-8">
          <div v-for="(lineDataLocal, index) in lineData" :key="lineData.name" :class="{'mt-4': index}">
            <div class="flex justify-between items-center">
              <div class="flex flex-col">
                <span class="mb-1">{{ lineDataLocal.name }}</span>
              </div>
              <div class="flex flex-col text-right">
                <span class="flex">
                   <h4 class="ml-auto">{{ lineDataLocal.value }}</h4>
                </span>
                <span class="text-grey">{{ lineDataLocal.ratio }}%</span>
              </div>
            </div>
            <vs-progress :percent="lineDataLocal.ratio" :color="lineDataLocal.color" height="10"></vs-progress>
          </div>
        </div>
      </div>
  </vx-card>
    <vx-card title="Статистика ошибок доставки" v-if="info">
      <div class="flex items-center" >
        <vue-apex-charts class="mt-5" style="min-width: 480px" type=donut height=325 :options="donateErrorsData.chartOptions" :series="donateErrorsData.series" />
        <div class="flex-1 px-8">
          <div v-for="(lineDataLocal, index) in lineErrorsData" :key="lineData.name" :class="{'mt-4': index}">
            <div class="flex justify-between items-center">
              <div class="flex flex-col">
                <span class="mb-1">{{ lineDataLocal.name }}</span>
              </div>
              <div class="flex flex-col text-right">
                <span class="flex">
                   <h4 class="ml-auto">{{ lineDataLocal.value }}</h4>
                </span>
                <span class="text-grey">{{ lineDataLocal.ratio }}%</span>
              </div>
            </div>
            <vs-progress :percent="lineDataLocal.ratio" :color="lineDataLocal.color" height="10"></vs-progress>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

  const EMAIL_STATUS_CODES = [
    { id: 0, name: 'В очереди на отправку', color: ''},
    { id: 1, name: 'Отправлено.', color: ''},
    { id: 2, name: 'Доставлено.', color: ''},
    { id: 3, name: 'Прочитано.', color: ''},
    { id: 4, name: 'Прочитано, квитанции просмотрены.', color: ''},
    { id: 5, name: 'Пользователь отписался от рассылки', color: ''},
    { id: 6, name: 'Адрес не существует, доставка не удалась.', color: ''},
    { id: 7, name: 'Временно недоступен', color: ''},
    { id: 8, name: 'Недоступен', color: ''},
    { id: 9, name: 'Письмо отклонено сервером как спам', color: ''},
    { id: 10, name:  'Почтовый ящик получателя переполнен', color: ''},
    { id: 11, name:  'Адресат считает письмо спамом', color: ''},
    { id: 12, name:  'Доставка не удалась по иным причинам.', color: ''},
    { id: 13, name:  'Не отправлено.', color: ''},
    { id: 14, name:  'Домен не существует.', color: ''},
    { id: 15, name:  'Отписался от рассылки.', color: ''},
    { id: 16, name:  'Отправка не удалась, email адрес невалидный', color: ''},
    { id: 17, name:  'Отправка временно запрещена', color: ''},
    { id: 18, name:  'Отключено администратором', color: ''}
  ];

  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: "EmailsHistory",
    components: {
      VueApexCharts
    },
    data(){
      return {
        EMAIL_STATUS_CODES: EMAIL_STATUS_CODES,
        analyticsData: {
          sessionsByDeviceDonut: {
          },
        },
        info: {},
      }
    },
    computed: {
      selectedHouseId(){
        return this.$store.getters['appUser/selectedHouse'].id;
      },
      emailCampaignId(){
        return this.$route.params.id;
      },
      statistic(){
        return this.info.statistic ? this.info.statistic : {};
      },
      mailStats(){
        return this.statistic.mails_stats ? this.statistic.mails_stats : [];
      },
      sended(){
        let stat = this.mailStats.find(stat => stat.code === 1);
        return stat ? stat.qty : 0;
      },
      delivered(){
        let stat = this.mailStats.find(stat => stat.code === 2);
        return stat ? stat.qty : 0;
      },
      errors(){
        let stats = this.mailStats.filter(stat => Number(stat.code) > 5);
        let statSum = 0;
        stats.forEach((stat) => {
          statSum += Number(stat.qty);
        });
        return statSum;
      },
      unsubscribed(){
        let stats = this.mailStats.filter(stat => Number(stat.code) === 5 || Number(stat.code) === 15);
        let statSum = 0;
        stats.forEach((stat) => {
          statSum += Number(stat.qty);
        });
        return statSum;
      },
      clicked(){
        let stat = this.mailStats.find(stat => stat.code === 4);
        return stat ? stat.qty : 0;
      },
      opened(){
        let stat = this.mailStats.find(stat => stat.code === 3);
        return stat ? stat.qty : 0;
      },
      disabledByAdmin(){
        let stat = this.mailStats.find(stat => stat.code === 18);
        return stat ? stat.qty : 0;
      },
      noAddress(){
        let stat = this.mailStats.find(stat => stat.code === 6);
        return stat ? stat.qty : 0;
      },
      notDelivered(){
        let stat = this.mailStats.find(stat => stat.code === 12);
        return stat ? stat.qty : 0;
      },
      denied(){
        let stat = this.mailStats.find(stat => stat.code === 17);
        return stat ? stat.qty : 0;
      },
      lineData(){
        return [
          {
            name: 'Открыто',
            value: this.opened,
            ratio: this.getPercent(this.opened, this.sended),
            color: 'primary'
          },
          {
            name: 'Переходов',
            value: this.clicked,
            ratio: this.getPercent(this.clicked, this.sended),
            color: 'success'
          },
          {
            name: 'Отписались',
            value: this.unsubscribed,
            ratio: this.getPercent(this.unsubscribed, this.sended),
            color: 'warning'
          },
          {
            name: 'Ошибок',
            value: this.errors,
            ratio: this.getPercent(this.errors, this.sended),
            color: 'danger'
          },
        ];
      },
      donateData(){
        return {
          series: [this.opened, this.errors, this.delivered - this.opened],
          chartOptions: {
            labels: ['Открыто', 'Ошибки отправки', 'Не прочитано'],
            dataLabels: {
              enabled: false
            },
            tooltip: {
              enabled: false
            },
            legend: { show: false },
            chart: {
              offsetY: 0,
              type: 'donut',
              toolbar: {
                show: false
              }
            },
            states: {
              normal: {
                filter: {
                  type: 'none',
                  value: 0,
                }
              },
              hover: {
                filter: {
                  type: 'darken',
                  value: 0.75,
                }
              },
              active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                  type: 'darken',
                  value: 0.75,
                }
              },
            },
            plotOptions: {
              pie: {
                expandOnClick: false,
                donut: {
                  labels: {
                    show: true,
                  }
                }
              }
            },
            stroke: { width: 0 },
            colors: ['#28C76F', '#EA5455', '#a0a3a8'],
            fill: {
              type: 'gradient',
              gradient: {
                gradientToColors: ['#2eff96', '#f29292', '#dae1e7']
              }
            }
          }
        }
      },
      lineErrorsData(){
        return [
          {
            name: 'Отключен администратором',
            value: this.disabledByAdmin,
            ratio: this.getPercent(this.disabledByAdmin, this.errors),
            color: 'primary'
          },
          {
            name: 'Адрес не существует',
            value: this.noAddress,
            ratio: this.getPercent(this.noAddress, this.errors),
            color: 'dark'
          },
          {
            name: 'Доставка не удалась',
            value: this.unsubscribed,
            ratio: this.getPercent(this.notDelivered, this.errors),
            color: 'danger'
          },
          {
            name: 'Доставка временно запрещена',
            value: this.denied,
            ratio: this.getPercent(this.denied, this.errors),
            color: 'warning'
          },
        ];
      },
      donateErrorsData(){
        return {
          series: [this.disabledByAdmin, this.noAddress, this.unsubscribed, this.denied],
          chartOptions: {
            labels: ['Отключен', 'Адрес не существует', 'Доставка не удалась', 'Временно запрещена'],
            dataLabels: {
              enabled: false
            },
            tooltip: {
              enabled: false
            },
            legend: { show: false },
            chart: {
              offsetY: 0,
              type: 'donut',
              toolbar: {
                show: false
              },
            },
            plotOptions: {
              pie: {
                expandOnClick: false,
                donut: {
                  labels: {
                    show: true,
                  }
                }
              }
            },
            states: {
              normal: {
                filter: {
                  type: 'none',
                  value: 0,
                }
              },
              hover: {
                filter: {
                  type: 'darken',
                  value: 0.75,
                }
              },
              active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                  type: 'darken',
                  value: 0.75,
                }
              },
            },
            stroke: { width: 0 },
            colors: ['#7367F0', '#1E1E1E', '#EA5455', '#FF9F43'],
            fill: {
              type: 'gradient',
              gradient: {
                gradientToColors: ['#9c8cfc', '#6e6e6e', '#f29292', '#FFC085'],
              }
            }
          }
        }
      },
    },
    methods: {
      async getEmailsHistory(){
        let {data} = await this.$http.get('emails_history/'+this.emailCampaignId+"?buildings_id="+this.selectedHouseId);
        this.info = data;

        let {data:statistic} = await this.$http.get('emails_history/'+this.emailCampaignId+'/refresh?buildings_id='+this.selectedHouseId);
        this.info.statistic = statistic;
      },
      getPercent(num, fromNum){
        let percent = (num / fromNum) * 100;
        return Number(percent.toFixed(2));
      }
    },
    mounted() {
      this.getEmailsHistory();
    }
  }
</script>